import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const WORDMARK = "https://customer-assets.emergentagent.com/job_executive-transform-3/artifacts/o3iwui7g_wordmark.jpg";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img src={WORDMARK} alt="kedve" className="h-14 w-auto object-contain" style={{ mixBlendMode: "screen" }} />
            <p className="mt-8 font-serif text-3xl leading-tight max-w-md">
              Build the capabilities that define great careers.
            </p>
            <Link
              to="/apply"
              data-testid="footer-apply"
              className="mt-10 inline-flex items-center gap-2 border border-white/40 hover:border-white rounded-full px-6 py-3 text-sm tracking-wide transition"
            >
              Begin your application <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-6 grid grid-cols-2 md:grid-cols-3 gap-8 text-sm">
            <FooterCol
              title="Platform"
              links={[
                ["Career Journey", "/career-journey"],
                ["Accelerators", "/accelerators"],
                ["Our Philosophy", "/philosophy"],
                ["Apply", "/apply"],
              ]}
            />
            <FooterCol
              title="For Business"
              links={[
                ["Enterprise", "/enterprise"],
                ["Leadership Fellowship", "/enterprise#fellowship"],
                ["Speak to kedve", "/enterprise#contact"],
              ]}
            />
            <FooterCol
              title="Contact"
              links={[
                ["learn@kedve.com", "mailto:learn@kedve.com"],
                ["Enterprise", "/enterprise"],
                ["Careers", "#"],
              ]}
            />
          </div>
        </div>

        <div className="mt-24 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between text-xs uppercase tracking-[0.2em] text-white/50 gap-4">
          <span>© {new Date().getFullYear()} kedve — All rights reserved</span>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Trust</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="eyebrow text-white/50">{title}</div>
      <ul className="mt-4 space-y-3">
        {links.map(([label, href]) => (
          <li key={label}>
            <Link to={href} className="text-white/80 hover:text-white transition link-underline">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
